/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Controls PDP account modal panels
 */
function showAccountPanel(panelId) {
    const btnRegister = document.getElementById('btn-register');
    const btnLogin = document.getElementById('btn-login');
  
    if (panelId === 'account-modal-register') {
        btnRegister.classList.add('--is-active');
        btnLogin.classList.remove('--is-active');
    } else {
        btnLogin.classList.add('--is-active');
        btnRegister.classList.remove('--is-active');
    }
  
    const panels = document.querySelectorAll('.modal__account-panel');
    panels.forEach(function(panel) {
        panel.setAttribute('data-account-panel-visible', 'false');
    });
    document.getElementById(panelId).setAttribute('data-account-panel-visible', 'true');
  }
  
  /** 
   * Account modal password visibility
   */
  function togglePasswordVisibility(button) {
    // Find the nearest parent form wrapper or specific container
    const formWrapper = button.closest('.form__input-wrapper');
    // Find the password input within this container
    const passwordInput = formWrapper.querySelector('.form__field--text');
  
    if (passwordInput.type === "password") {
      passwordInput.type = "text";
      button.textContent = 'Hide';
    } else {
      passwordInput.type = "password";
      button.textContent = 'Show';
    }
  }
  
  /**
   * Tracking last page visited > sessionStorage
   */
  document.addEventListener("DOMContentLoaded", function() {
    // Get the current page's path
    let path = window.location.pathname;
  
    // Regular expression to validate the path
    let regex = /^\/[^.]*$/;
  
    // Check if the current page's path is not "/account/login" and not "/account/register"
    if (path !== "/account/login" && path !== "/account/register" && path !== "/challenge") {
        // Validate the path and store it in sessionStorage
        if (regex.test(path)) {
            sessionStorage.setItem("returnToPath", path);
        } else {
            return
        }
    } else if (path === "/account/login" || path === "/account/register") {
        // Check if the sessionStorage variable exists
        if (sessionStorage.getItem("returnToPath")) {
            // Select the form element with the class "form--main" and the hidden input field named "return_to"
            let form = document.querySelector('.form--main');
            if (form) {
                let hiddenInput = form.querySelector('input[name="return_to"]');
  
                // Set the value of the hidden input field to the value stored in sessionStorage
                if (hiddenInput) {
                    hiddenInput.value = sessionStorage.getItem("returnToPath");
                    console.log("Set hidden input value to:", hiddenInput.value);
                }
            }
        } else {
            console.log("No path in session storage");
        }
    }
  });
  
/**
 * Handling direct recovery form link from PDP account modal
 */
document.addEventListener('DOMContentLoaded', function() {
// Checks for the presence of the success message
const successMessage = document.querySelector('.alert--success');

// Only run the form toggling logic if there's no success message displayed
if (!successMessage) {
    const urlParams = new URLSearchParams(window.location.search);
    const recover = urlParams.get('recover');

    // Select the specific forms by class name 'form--main'
    const loginForm = document.querySelector('.form--main[name="login"]');
    const recoverForm = document.querySelector('.form--main[name="recover"]');

    if (recover === 'true') {
    if (loginForm) loginForm.style.display = 'none';
    if (recoverForm) recoverForm.style.display = 'block';
    } else {
    if (loginForm) loginForm.style.display = 'block';
    if (recoverForm) recoverForm.style.display = 'none';
    }
}
});

/** 
 * Function to update the ATC button based on variant availability and customer login status
 */
function updateATCButtonAvailability(variant) {
const paymentContainer = document.querySelector('.product-form__payment-container');
const loginStatus = paymentContainer.dataset.loggedIn;

if (loginStatus === "ignore") {
    return; // Bypass any logic if the product does not require checks
}

const addToCartButton = paymentContainer.querySelector('.product-form__add-button');

if (!variant.available || loginStatus === 'false') {
    addToCartButton.setAttribute('disabled', 'disabled');
    addToCartButton.classList.add('button--disabled');
    addToCartButton.classList.remove('button--primary');

    // Determine the message based on availability or login status
    if (!variant.available) {
        addToCartButton.innerHTML = window.languages.productFormSoldOut; // Default sold out message
    } else {
        addToCartButton.innerHTML = "Account required"; // Custom message for logged out users
    }
} else {
    addToCartButton.removeAttribute('disabled');
    addToCartButton.classList.remove('button--disabled');
    addToCartButton.classList.add('button--primary');
    addToCartButton.innerHTML = window.languages.productFormAddToCart;
}
}
  
/** 
 * Event listener to handle variant changes
 */
  document.addEventListener('variant:changed', function(e) {
    updateATCButtonAvailability(e.detail.variant);
  });
/**
 * END PDP account modal panels
 */